<template>
  <modal-default
    ref="commEmailModal"
    subtitle="EMAIL"
    :title="contact.full_name"
    :width="1000"
  >
    <keep-alive>
      <component
        :is="commEmailComponent"
        v-bind="currentProps"
      ></component>
    </keep-alive>
  </modal-default>
</template>

<script>
import CommEmailModalDesktop from "./CommEmailModalDesktop";
import CommEmailModalMobile from "./CommEmailModalMobile";
import {EventBus} from "../../event-bus";

export default {
  name: "CommEmailModal",
  components: {
    CommEmailModalDesktop,
    CommEmailModalMobile,
  },
  props: {
    contact: {
      type: Object,
      required: true
    },
    record: Object,
    availableRecords: {
      type: Array,
    }
  },
  data() {
    return {
      comms: []
    };
  },
  mounted() {
    EventBus.$on("closeCommEmailModal", () => {
      this.$refs.commEmailModal.close();
    });
  },
  computed: {
    commEmailComponent() {
      if (this.$store.state.isMobile) {
        return "CommEmailModalMobile";
      }

      return "CommEmailModalDesktop";
    },
    currentProps() {
      return {
        contact: this.contact,
        comms: this.comms,
        record: this.record,
        availableRecords: this.availableRecords
      };
    }
  },
  methods: {
    open() {
      this.loadComms();
      this.$refs.commEmailModal.open();
      this.$emit("open");
    },
    loadComms() {
      if (this.record) {
        this.$api.communicationLogs.allForRecord(this.record.id).then(response => {
          this.comms = response.data.data;
        });
      } else {
        this.$api.communicationLogs.allForContact(this.contact.id).then(response => {
          this.comms = response.data;
        })
      }
    },
  }
};
</script>

<style lang="scss" scoped>

::v-deep {

  .modal-card-body {
    height: calc(100vh - 80px - 41px);
  }

  .modal-inner {
    height: 100%;
    padding: 0;
  }
}
</style>
